import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { PlayerProvider } from './context/PlayerContext';
import { I18nProvider } from './i18n';
import Navbar from './components/Navbar/Navbar';
import Footer from './components/Footer/Footer';
import LoadingScreen from './components/LoadingScreen/LoadingScreen';
import ParticleBackground from './components/ParticleBackground/ParticleBackground';
import ProtectedRoute from './components/ProtectedRoute/ProtectedRoute';
import CartSidebar from './components/CartSidebar/CartSidebar';

const Home = lazy(() => import('./pages/Home/Home'));
const Login = lazy(() => import('./pages/Login/Login'));
const Store = lazy(() => import('./pages/Store/Store'));
const PaymentSuccess = lazy(() => import('./pages/PaymentSuccess/PaymentSuccess'));
const Dashboard = lazy(() => import('./pages/Dashboard/Dashboard'));
const Settings = lazy(() => import('./pages/Settings/Settings'));
const About = lazy(() => import('./pages/About/About'));
const Blog = lazy(() => import('./pages/Blog/Blog'));
const Contact = lazy(() => import('./pages/Contact/Contact'));
const FAQ = lazy(() => import('./pages/FAQ/FAQ'));
const Admin = lazy(() => import('./pages/Admin/Admin'));
const NotFound = lazy(() => import('./pages/NotFound/NotFound'));

const App: React.FC = () => {
  return (
    <Router>
      <AuthProvider>
        <I18nProvider>
          <PlayerProvider>
            <CartProvider>
            <div className="app">
              <ParticleBackground />
              <Navbar />
              <main className="main-content">
                <Suspense fallback={<LoadingScreen />}>
                  <Routes>
                    <Route path="/" element={<Home />} />
                    <Route path="/login" element={<Login />} />
                    <Route path="/store" element={<Store />} />
                    <Route path="/payment/success" element={<ProtectedRoute><PaymentSuccess /></ProtectedRoute>} />
                    <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
                    <Route path="/dashboard/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                    <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
                    <Route path="/about" element={<About />} />
                    <Route path="/blog" element={<Blog />} />
                    <Route path="/blog/:slug" element={<Blog />} />
                    <Route path="/contact" element={<Contact />} />
                    <Route path="/faq" element={<FAQ />} />
                    <Route path="/admin" element={<ProtectedRoute requiredPermissions={['admin.access', 'admin.full']}><Admin /></ProtectedRoute>} />
                    <Route path="*" element={<NotFound />} />
                  </Routes>
                </Suspense>
              </main>
              <Footer />
              <CartSidebar />
            </div>
          </CartProvider>
        </PlayerProvider>
      </I18nProvider>
    </AuthProvider>
    </Router>
  );
};

export default App;
